import React, { Component } from 'react';
import NavBarWidget from './NavBarWidget';

import {
  StyledWidgetLayout,
  StyledHeaderWrapper,
  StyledMove,
  StyledContent,
  StyledLogo,
  StyledLinkMinimize,
  StyledIconMinimize,
  StyledScrollbars
} from './style';

import Logo from '../../../../assets/images/logo.svg';
import { Minimize } from '../../../../assets/images';

class LayoutElectron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animate: false
    };
  }

  componentDidMount() {
    document.body.style.overflowY = 'hidden';
  }

  setAnimate = e => {
    const ANIMATE_Y = 10;

    if (e.target.scrollTop > ANIMATE_Y) {
      this.setState({
        animate: true
      });
    } else {
      this.setState({
        animate: false
      });
    }
  };

  onMinimize = async () => {
    let res = false;
    const { ipcRenderer } = window.require('electron');
    const minimized = await ipcRenderer.sendSync('minimize-widget');
    if (minimized) {
      res = true;
    }
    return res;
  };

  render(props) {
    const { animate } = this.state;

    return (
      <StyledWidgetLayout animate={animate}>
        <StyledHeaderWrapper>
          <StyledLogo svg={Logo} className="Header-logo" />
          <StyledMove />
          <StyledLinkMinimize onClick={() => this.onMinimize()}>
            <StyledIconMinimize className="LayoutElectron-min" svg={Minimize} />
          </StyledLinkMinimize>
        </StyledHeaderWrapper>
        <StyledScrollbars onScroll={e => this.setAnimate(e)}>
          <StyledContent>{this.props.children}</StyledContent>
        </StyledScrollbars>
        <NavBarWidget {...props} />
      </StyledWidgetLayout>
    );
  }
}

export default LayoutElectron;
